import { fetcher } from '@bilibili-maoer/web-utils';
import { toggleToast } from '../toast/index.js';

var _fetcher$createFetche = fetcher.createFetchers(),
    getFetch = _fetcher$createFetche.getFetch,
    postFetch = _fetcher$createFetche.postFetch;

var _fetcher$createFetche2 = fetcher.createFetchers({
  onError: function onError(err) {
    toggleToast(err.message);
  }
});
    _fetcher$createFetche2.getFetch;
    var postFetchWithErrorToast = _fetcher$createFetche2.postFetch;
var EAPIErrorCode;

(function (EAPIErrorCode) {
  /* eslint-disable no-magic-numbers */
  EAPIErrorCode[EAPIErrorCode["PopupModalRequired"] = 100010018] = "PopupModalRequired";
  EAPIErrorCode[EAPIErrorCode["PromptFeedbackModal"] = 100010021] = "PromptFeedbackModal";
  /* eslint-enable no-magic-numbers */
})(EAPIErrorCode || (EAPIErrorCode = {}));

export { EAPIErrorCode, getFetch, postFetch, postFetchWithErrorToast };
